import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import {addNotification} from "./notifications";
import {saveFile} from "../lib/content-lib";

export const GET_CUSTOMERS_REQUEST = 'GET_CUSTOMERS_REQUEST';
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS';
export const GET_CUSTOMERS_ERROR = 'GET_CUSTOMERS_ERROR';

export const GET_CUSTOMER_REQUEST = 'GET_CUSTOMER_REQUEST';
export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS';
export const GET_CUSTOMER_ERROR = 'GET_CUSTOMER_ERROR';

export const CREATE_CUSTOMER_REQUEST = 'CREATE_CUSTOMER_REQUEST';
export const CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS';
export const CREATE_CUSTOMER_ERROR = 'CREATE_CUSTOMER_ERROR';

export const UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_ERROR = 'UPDATE_CUSTOMER_ERROR';

export const CHANGE_STATUS_CUSTOMER_REQUEST = 'CHANGE_STATUS_CUSTOMER_REQUEST';
export const CHANGE_STATUS_CUSTOMER_SUCCESS = 'CHANGE_STATUS_CUSTOMER_SUCCESS';
export const CHANGE_STATUS_CUSTOMER_ERROR = 'CHANGE_STATUS_CUSTOMER_ERROR';

export const UPLOAD_CUSTOMER_FILES_REQUEST = 'UPLOAD_CUSTOMER_FILES_REQUEST';
export const UPLOAD_CUSTOMER_FILES_PROGRESS = 'UPLOAD_CUSTOMER_FILES_PROGRESS';
export const UPLOAD_CUSTOMER_FILES_SUCCESS = 'UPLOAD_CUSTOMER_FILES_SUCCESS';
export const UPLOAD_CUSTOMER_FILES_ERROR = 'UPLOAD_CUSTOMER_FILES_ERROR';

export const DELETE_CUSTOMER_FILE_REQUEST = 'DELETE_CUSTOMER_FILE_REQUEST';
export const DELETE_CUSTOMER_FILE_SUCCESS = 'DELETE_CUSTOMER_FILE_SUCCESS';
export const DELETE_CUSTOMER_FILE_ERROR = 'DELETE_CUSTOMER_FILE_ERROR';

export const DELETE_CUSTOMER_REQUEST = 'DELETE_CUSTOMER_REQUEST';
export const DELETE_CUSTOMER_SUCCESS = 'DELETE_CUSTOMER_SUCCESS';
export const DELETE_CUSTOMER_ERROR = 'DELETE_CUSTOMER_ERROR';

export const CLEAN_CUSTOMERS = 'CLEAN_CUSTOMERS';

// Get customers
export function getCustomers(query) {
    return async (dispatch) => {
        try {
            dispatch(getCustomersRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/customers/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getCustomersSuccess, getCustomersError));
        } catch (err) {
            dispatch(utilsLib.response(err, getCustomersError));
        }
    };
}

function getCustomersRequest() {
    return {
        type: GET_CUSTOMERS_REQUEST,
        isFetching: true
    };
}

function getCustomersSuccess (payload) {
    return {
        type: GET_CUSTOMERS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getCustomersError(errorMessage) {
    return {
        type: GET_CUSTOMERS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get customer
export function getCustomer(customerId) {

    return async (dispatch) => {
        try {
            dispatch(getCustomerRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/customers/${customerId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getCustomerSuccess, getCustomerError));
        } catch (err) {
            dispatch(utilsLib.response(err, getCustomerError));
        }
    };
}

function getCustomerRequest() {
    return {
        type: GET_CUSTOMER_REQUEST,
        isFetching: true
    };
}

function getCustomerSuccess (payload) {
    return {
        type: GET_CUSTOMER_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getCustomerError(errorMessage) {
    return {
        type: GET_CUSTOMER_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create customer
export function createCustomer(customer) {
    return async (dispatch) => {
        try {
            dispatch(createCustomerRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/customers', customer, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createCustomerSuccess, createCustomerError));
        } catch (err) {
            dispatch(utilsLib.response(err, createCustomerError));
        }
    };
}

function createCustomerRequest() {
    return {
        type: CREATE_CUSTOMER_REQUEST,
        isFetching: true
    };
}

function createCustomerSuccess (payload) {
    return dispatch => {
        // Create notification for create customer success
        dispatch(addNotification({
            message: 'Cliente creado correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_CUSTOMER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function createCustomerError(errorMessage) {
    return dispatch => {
        // Create notification for create customer error
        dispatch(addNotification({
            message: 'Error al crear el cliente',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_CUSTOMER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update customer
export function updateCustomer(customerId, customer = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateCustomerRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/customers/${customerId}`, customer, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateCustomerSuccess, updateCustomerError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateCustomerError));
        }
    };
}

function updateCustomerRequest() {
    return {
        type: UPDATE_CUSTOMER_REQUEST,
        isFetching: true
    };
}

function updateCustomerSuccess (payload) {
    return dispatch => {
        // Create notification for update customer success
        dispatch(addNotification({
            message: 'Cliente actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: UPDATE_CUSTOMER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function updateCustomerError(errorMessage) {
    return dispatch => {
        // Create notification for update customer error
        dispatch(addNotification({
            message: 'Error al actualizar el cliente',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_CUSTOMER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change customer status
export function changeCustomerStatus(customerId, status) {
    return async (dispatch) => {
        try {
            dispatch(changeCustomerStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/customers/${customerId}/status`, { status }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changeCustomerStatusSuccess, changeCustomerStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changeCustomerStatusError));
        }
    };
}

function changeCustomerStatusRequest() {
    return {
        type: CHANGE_STATUS_CUSTOMER_REQUEST,
        isFetching: true
    };
}

function changeCustomerStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_CUSTOMER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function changeCustomerStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status error
        dispatch(addNotification({
            message: 'Error al actualizar el estado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_CUSTOMER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload customer files
export function uploadCustomerFiles(customerId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadCustomerFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/customers/${customerId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadCustomerFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadCustomerFilesSuccess, uploadCustomerFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadCustomerFilesError));
        }
    };
}
function uploadCustomerFilesRequest() {
    return {
        type: UPLOAD_CUSTOMER_FILES_REQUEST,
        isFetching: true
    };
}
function uploadCustomerFilesProgress(percent) {
    return {
        type: UPLOAD_CUSTOMER_FILES_PROGRESS,
        percent
    };
}
function uploadCustomerFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload customer file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_CUSTOMER_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadCustomerFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload customer file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_CUSTOMER_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download customer file
export function downloadCustomerFile(customerId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/customers/${customerId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete customer file
export function deleteCustomerFile(customerId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deleteCustomerFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/customers/${customerId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteCustomerFileSuccess, deleteCustomerFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteCustomerFileError));
        }
    };
}
function deleteCustomerFileRequest() {
    return {
        type: DELETE_CUSTOMER_FILE_REQUEST,
        isFetching: true
    };
}
function deleteCustomerFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_CUSTOMER_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteCustomerFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_CUSTOMER_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete customer
export function deleteCustomer(customerId) {

    return async (dispatch) => {
        try {
            dispatch(deleteCustomerRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/customers/${customerId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteCustomerSuccess, deleteCustomerError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteCustomerError));
        }
    };
}

function deleteCustomerRequest() {
    return {
        type: DELETE_CUSTOMER_REQUEST,
        isFetching: true
    };
}

function deleteCustomerSuccess (payload) {
    return dispatch => {
        // Create notification for delete customer success
        dispatch(addNotification({
            message: 'Cliente eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_CUSTOMER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function deleteCustomerError(errorMessage) {
    return dispatch => {
        // Create notification for delete customer error
        dispatch(addNotification({
            message: 'Error al eliminar el cliente',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_CUSTOMER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean customers reducer
export function cleanCustomers() {
    return {
        type: 'CLEAN_CUSTOMERS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/customers.js